import Cookies from 'universal-cookie'

const cookies = new Cookies()

export default {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${cookies.get('auth')}`
}